export const toAmount = amount => (
  new Intl.NumberFormat('en-NG', {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
    // style: 'currency',
    // currency: 'NGN',
  }).format(Number(amount))
)

export const addNumberSeparator = number => Number(number).toLocaleString()

export const toKobo = value => (
  Number(((value) * 100).toFixed())
)

export const toBalance = value => (
  Number.isInteger(Number(value)) ? toAmount(Number(value) / 100) : value
)

export const toLedgerBalance = value => (
  toAmount(Number(value) * 100)
)

export const formatAmount = value => (
  Number(value) / 100
)
export const toFormatAmount = value => (
  (Number(value) / 100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
  // (Number(value) / 100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,').replace('.00', '')
)
export const toFormatBalance = value => (
  (Number(value) / 100).toFixed(2)
)

export const removeMoneyFormat = value => {
  let newText = value?.replace(/\s/g, '').replace(/,/g, '')
  if (Number.isNaN(Number(value[0]))) {
    newText = newText.substring(1, newText.length)
  }
  return newText
}

export const containsFormattedNumber = str => {
  if (str) {
    const regex = /\b\d{1,3}(,\d{3})*\.\d{2}\b/
    return regex.test(str)
  }
  return null
}
export const removeCommas = str => {
  if (str) {
    return str.replace(/,/g, '')
  }
  return null
}

export const datass = [
  {
    id: '7beeb1c6-12e7-eb11-82dc-0abb463f1216',
    name: 'DISBURSE_LOAN',
    description: 'Disburse Loan',
    groupName: 'Customer Account Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '4ceeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'CREATE_USER',
    description: 'Create User',
    groupName: 'User Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '4deeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'MODIFY_USER',
    description: 'Modify User',
    groupName: 'User Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '4eeeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'ACTIVATE_USER',
    description: 'Activate User',
    groupName: 'User Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '4feeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'DEACTIVATE_USER',
    description: 'Deactivate User',
    groupName: 'User Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '50eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'VIEW_USER',
    description: 'View User',
    groupName: 'User Management',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '51eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'CREATE_USER_ROLE',
    description: 'Create User Role',
    groupName: 'User Role Management',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '52eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'MODIFY_USER_ROLE',
    description: 'Modify User Role',
    groupName: 'User Role Management',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '53eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'ACTIVATE_USER_ROLE',
    description: 'Activate User Role',
    groupName: 'User Role Management',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '54eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'DEACTIVATE_USER_ROLE',
    description: 'Deactivate User Role',
    groupName: 'User Role Management',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '55eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'VIEW_USER_ROLE',
    description: 'View User Role',
    groupName: 'User Role Management',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '56eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'CREATE_BRANCH',
    description: 'Create Branch',
    groupName: 'Branch Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '57eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'MODIFY_BRANCH',
    description: 'Modify Branch',
    groupName: 'Branch Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '58eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'ACTIVATE_BRANCH',
    description: 'Activate Branch ',
    groupName: 'Branch Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: true,
  },
  {
    id: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
    name: 'ACTIVATE_MANDATE_STATUS',
    description: 'Activate Mandate Status',
    groupName: 'E-Channels Management',
    isApprovable: false,
    dateCreated: '2022-03-10T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '5aeeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'VIEW_BRANCH',
    description: 'View Branch',
    groupName: 'Branch Management',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '5beeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'CREATE_REGION',
    description: 'Create Region',
    groupName: 'Region Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '5ceeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'MODIFY_REGION',
    description: 'Modify Region',
    groupName: 'Region Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '5deeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'ACTIVATE_REGION',
    description: 'Activate Region',
    groupName: 'Region Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '5eeeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'DEACTIVATE_REGION',
    description: 'Deactivate Region',
    groupName: 'Region Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '5feeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'VIEW_REGION',
    description: 'View Region',
    groupName: 'Region Management',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '60eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'MODIFY_SYSTEM_SETUP',
    description: 'Modify System Setup',
    groupName: 'System Setup',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '61eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'VIEW_SYSTEM_SETUP',
    description: 'View System Setup',
    groupName: 'System Setup',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '62eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'CREATE_LIEN',
    description: 'Create Lien',
    groupName: 'Lien Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '63eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'MODIFY_LIEN',
    description: 'Modify Lien',
    groupName: 'Lien Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '64eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'ACTIVATE_LIEN',
    description: 'Activate Lien',
    groupName: 'Lien Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '65eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'DEACTIVATE_LIEN',
    description: 'Deactivate Lien',
    groupName: 'Lien Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '66eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'VIEW_LIEN',
    description: 'View Lien',
    groupName: 'Lien Management',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '67eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'OPEN_CLOSE_BRANCH',
    description: 'Open/Close Branch',
    groupName: 'Business Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '68eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'OPEN_CLOSE_BUSINESS',
    description: 'Open/Close Business',
    groupName: 'Business Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '69eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'OPEN_CLOSE_BUSINESS_HISTORY',
    description: 'Open/Close Business History',
    groupName: 'Business Management',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '6aeeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'AUDIT_TRAIL',
    description: 'Audit Trail',
    groupName: 'Audit Trail Management',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '6beeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'CREATE_APPROVAL_SETUP',
    description: 'Create Approval Setup',
    groupName: 'Approval Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '6ceeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'MODIFY_APPROVAL_SETUP',
    description: 'Modify Approval Setup',
    groupName: 'Approval Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '6deeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'VIEW_APPROVAL_SETUP',
    description: 'View Approval Setups',
    groupName: 'Approval Management',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '6eeeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'CREATE_BUSINESS_AUTOMATION',
    description: 'Create Business Automation',
    groupName: 'Business Automation Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '6feeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'MODIFY_BUSINESS_AUTOMATION',
    description: 'Modify Business Automation',
    groupName: 'Business Automation Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '70eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'ACTIVATE_BUSINESS_AUTOMATION',
    description: 'Activate Business Automation',
    groupName: 'Business Automation Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '71eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'DEACTIVATE_BUSINESS_AUTOMATION',
    description: 'Deactivate Business Automation',
    groupName: 'Business Automation Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '72eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'VIEW_BUSINESS_AUTOMATION',
    description: 'View Business Automation',
    groupName: 'Business Automation Management',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '73eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'CREATE_SAVING_CURRENT_ACCOUNT',
    description: 'Create Saving/Current Account',
    groupName: 'Customer Account Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '74eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'MODIFY_SAVING_CURRENT_ACCOUNT',
    description: 'Modify Saving/Current Account',
    groupName: 'Customer Account Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '75eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'ACTIVATE_SAVING_CURRENT_ACCOUNT',
    description: 'Activate Saving/Current Account',
    groupName: 'Customer Account Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '76eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'DEACTIVATE_SAVING_CURRENT_ACCOUNT',
    description: 'Deactivate Saving/Current Account',
    groupName: 'Customer Account Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '77eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'VIEW_SAVING_CURRENT_ACCOUNT',
    description: 'View Saving/Current Account',
    groupName: 'Customer Account Management',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '78eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'VIEW_CUSTOMER_ACCOUNT_BALANCE',
    description: 'View Customer Account Balance',
    groupName: 'Customer Account Management',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '79eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'CLOSE_CUSTOMER_ACCOUNT',
    description: 'Customer Account Closure',
    groupName: 'Customer Account Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '7aeeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'VIEW_CLOSED_ACCOUNTS',
    description: 'View Closed Accounts',
    groupName: 'Customer Account Management',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '7beeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'CREATE_LOAN_ACCOUNT',
    description: 'Create Loan Account',
    groupName: 'Customer Account Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '7ceeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'MODIFY_LOAN_ACCOUNT',
    description: 'Modify Loan Account',
    groupName: 'Customer Account Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '7deeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'VIEW_LOAN_ACCOUNT',
    description: 'View Loan Account',
    groupName: 'Customer Account Management',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '7eeeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'CREATE_FIXED_DEPOSIT_ACCOUNT',
    description: 'Create Fixed Deposit  Account',
    groupName: 'Customer Account Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '7feeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'MODIFY_FIXED_DEPOSIT_ACCOUNT',
    description: 'Modify Fixed Deposit Account',
    groupName: 'Customer Account Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '80eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'LIQUIDATE_FIXED_DEPOSIT_ACCOUNT',
    description: 'Liquidate Fixed Deposit Account',
    groupName: 'Customer Account Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '81eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'VIEW_FIXED_DEPOSIT_ACCOUNT',
    description: 'View Fixed Deposit Account',
    groupName: 'Customer Account Management',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '82eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'CREATE_OVERDRAFT',
    description: 'Create Overdraft',
    groupName: 'Overdraft',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '83eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'MODIFY_OVERDRAFT',
    description: 'Modify Overdraft',
    groupName: 'Overdraft',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '84eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'VIEW_OVERDRAFT',
    description: 'View Overdraft Accounts',
    groupName: 'Overdraft',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '85eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'ACTIVATE_OVERDRAFT',
    description: 'Activate Overdraft',
    groupName: 'Overdraft',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '86eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'DEACTIVATE_OVERDRAFT',
    description: 'Deactivate Overdraft',
    groupName: 'Overdraft',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '87eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'CREATE_GENERAL_LEDGER',
    description: 'Create General Ledger',
    groupName: 'General Ledger Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '88eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'MODIFY_GENERAL_LEDGER',
    description: 'Modify General Ledger',
    groupName: 'General Ledger Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '89eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'VIEW_GENERAL_LEDGER',
    description: 'View General Ledger',
    groupName: 'General Ledger Management',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '8aeeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'ACTIVATE_GENERAL_LEDGER',
    description: 'Activate General Ledger',
    groupName: 'General Ledger Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '8beeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'DEACTIVATE_GENERAL_LEDGER',
    description: 'Deactivate General Ledger ',
    groupName: 'General Ledger Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '8ceeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'CREATE_COT_FEE',
    description: 'Create COT Fee',
    groupName: 'Fee Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '8deeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'MODIFY_COT_FEE',
    description: 'Modify COT Fee',
    groupName: 'Fee Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '8eeeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'VIEW_COT_FEE',
    description: 'View COT Fee',
    groupName: 'Fee Management',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '8feeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'ACTIVATE_COT_FEE',
    description: 'Activate COT Fee',
    groupName: 'Fee Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '90eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'DEACTIVATE_COT_FEE',
    description: 'Deactivate COT Fee',
    groupName: 'Fee Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '91eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'CREATE_OVERDRAFT_FEE',
    description: 'Create Overdraft Fee',
    groupName: 'Fee Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '92eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'MODIFY_OVERDRAFT_FEE',
    description: 'Modify Overdraft Fee',
    groupName: 'Fee Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '93eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'VIEW_OVERDRAFT_FEE',
    description: 'View Overdraft Fee',
    groupName: 'Fee Management',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '94eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'ACTIVATE_OVERDRAFT_FEE',
    description: 'Activate Overdraft Fee',
    groupName: 'Fee Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '95eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'DEACTIVATE_OVERDRAFT_FEE',
    description: 'Deactivate Overdraft Fee',
    groupName: 'Fee Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '96eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'CREATE_LOAN_FEE',
    description: 'Create Loan Fee',
    groupName: 'Fee Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '97eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'MODIFY_LOAN_FEE',
    description: 'Modify Loan Fee',
    groupName: 'Fee Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '98eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'VIEW_LOAN_FEE',
    description: 'View Loan Fee',
    groupName: 'Fee Management',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '99eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'ACTIVATE_LOAN_FEE',
    description: 'Activate Loan Fee',
    groupName: 'Fee Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '9aeeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'DEACTIVATE_LOAN_FEE',
    description: 'Deactivate Loan Fee',
    groupName: 'Fee Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '9beeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'CREATE_INTEREST',
    description: 'Create Interest',
    groupName: 'Interest Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '9ceeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'MODIFY_INTEREST',
    description: 'Modify Interest',
    groupName: 'Interest Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '9deeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'VIEW_INTEREST',
    description: 'View Interest',
    groupName: 'Interest Management',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '9eeeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'ACTIVATE_INTEREST',
    description: 'Activate Interest',
    groupName: 'Interest Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '9feeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'DEACTIVATE_INTEREST',
    description: 'Deactivate Interest',
    groupName: 'Interest Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'a0eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'CREATE_CHARGE',
    description: 'Create Charge',
    groupName: 'Charge Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'a1eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'MODIFY_CHARGE',
    description: 'Modify Charge',
    groupName: 'Charge Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'a2eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'VIEW_CHARGE',
    description: 'View Charge',
    groupName: 'Charge Management',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'a3eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'ACTIVATE_CHARGE',
    description: 'Activate Charge',
    groupName: 'Charge Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'a4eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'DEACTIVATE_CHARGE',
    description: 'Deactivate Charge',
    groupName: 'Charge Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'a5eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'CREATE_INDIVIDUAL_CUSTOMER',
    description: 'Create Individual Customer',
    groupName: 'Customer Information Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'a6eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'MODIFY_INDIVIDUAL_CUSTOMER',
    description: 'Modify Individual Customer',
    groupName: 'Customer Information Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'a7eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'VIEW_INDIVIDUAL_CUSTOMER',
    description: 'View Individual Customer',
    groupName: 'Customer Information Management',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'a8eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'ACTIVATE_INDIVIDUAL_CUSTOMER',
    description: 'Activate Individual Customer',
    groupName: 'Customer Information Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'a9eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'DEACTIVATE_INDIVIDUAL_CUSTOMER',
    description: 'Deactivate Individual Customer',
    groupName: 'Customer Information Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'aaeeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'CREATE_GROUP_CUSTOMER',
    description: 'Create Group Customer',
    groupName: 'Customer Information Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'abeeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'MODIFY_GROUP_CUSTOMER',
    description: 'Modify Group Customer',
    groupName: 'Customer Information Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'aceeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'VIEW_GROUP_CUSTOMER',
    description: 'View Group Customer',
    groupName: 'Customer Information Management',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'adeeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'ACTIVATE_GROUP_CUSTOMER',
    description: 'Activate Group Customer',
    groupName: 'Customer Information Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'aeeeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'DEACTIVATE_GROUP_CUSTOMER',
    description: 'Deactivate Group Customer',
    groupName: 'Customer Information Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'afeeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'CREATE_CORPORATE_CUSTOMER',
    description: 'Create Corporate Customer',
    groupName: 'Customer Information Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'b0eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'MODIFY_CORPORATE_CUSTOMER',
    description: 'Modify Corporate Customer',
    groupName: 'Customer Information Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'b1eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'VIEW_CORPORATE_CUSTOMER',
    description: 'View Corporate Customer',
    groupName: 'Customer Information Management',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'b2eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'ACTIVATE_CORPORATE_CUSTOMER',
    description: 'Activate Corporate Customer',
    groupName: 'Customer Information Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'b3eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'DEACTIVATE_CORPORATE_CUSTOMER',
    description: 'Deactivate Corporate Customer',
    groupName: 'Customer Information Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'b4eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'CREATE_SAVING_CURRENT_PRODUCT',
    description: 'Create Saving/Current Product',
    groupName: 'Product Manangement',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'b5eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'MODIFY_SAVING_CURRENT_PRODUCT',
    description: 'Modify Saving/Current Product',
    groupName: 'Product Manangement',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'b6eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'VIEW_SAVING_CURRENT_PRODUCT',
    description: 'View Saving/Current Product',
    groupName: 'Product Manangement',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'b7eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'ACTIVATE_SAVING_CURRENT_PRODUCT',
    description: 'Activate Saving/Current Product',
    groupName: 'Product Manangement',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'b8eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'DEACTIVATE_SAVING_CURRENT_PRODUCT',
    description: 'Deactivate Saving/Current Product',
    groupName: 'Product Manangement',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'b9eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'CREATE_LOAN_PRODUCT',
    description: 'Create Loan Product',
    groupName: 'Product Manangement',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'baeeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'MODIFY_LOAN_PRODUCT',
    description: 'Modify Loan Product',
    groupName: 'Product Manangement',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'bbeeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'VIEW_LOAN_PRODUCT',
    description: 'View Loan Product',
    groupName: 'Product Manangement',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'bceeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'ACTIVATE_LOAN_PRODUCT',
    description: 'Activate Loan Product',
    groupName: 'Product Manangement',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'bdeeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'DEACTIVATE_LOAN_PRODUCT',
    description: 'Deactivate Loan Product',
    groupName: 'Product Manangement',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'beeeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'CREATE_FIXED_DEPOSIT_PRODUCT',
    description: 'Create Loan Product',
    groupName: 'Product Manangement',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'bfeeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'MODIFY_FIXED_DEPOSIT_PRODUCT',
    description: 'Modify Loan Product',
    groupName: 'Product Manangement',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'c0eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'VIEW_FIXED_DEPOSIT_PRODUCT',
    description: 'View Loan Product',
    groupName: 'Product Manangement',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'c1eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'ACTIVATE_FIXED_DEPOSIT_PRODUCT',
    description: 'Activate Loan Product',
    groupName: 'Product Manangement',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'c2eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'DEACTIVATE_FIXED_DEPOSIT_PRODUCT',
    description: 'Deactivate Loan Product',
    groupName: 'Product Manangement',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'c3eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'CREATE_ACCOUNT_OFFICER',
    description: 'Create Account Officer',
    groupName: 'Account Officer Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'c4eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'MODIFY_ACCOUNT_OFFICER',
    description: 'Modify Account Officer',
    groupName: 'Account Officer Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'c5eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'VIEW_ACCOUNT_OFFICER',
    description: 'View Account Officer',
    groupName: 'Account Officer Management',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'c6eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'ACTIVATE_ACCOUNT_OFFICER',
    description: 'Activate Account Officer',
    groupName: 'Account Officer Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'c7eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'DEACTIVATE_ACCOUNT_OFFICER',
    description: 'Deactivate Account Officer',
    groupName: 'Account Officer Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'c8eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'CASH_DEPOSIT_POSTING',
    description: 'Cash Deposit Posting',
    groupName: 'Posting Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'c9eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'VIEW_CASH_DEPOSIT_POSTING_LIST',
    description: 'View Cash Deposits Posting',
    groupName: 'Posting Management',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'caeeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'CASH_WITHDRAWAL_POSTING',
    description: 'Cash Withdrawal Posting',
    groupName: 'Posting Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'cbeeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'VIEW_CASH_WITHDRAWAL_POSTING_LIST',
    description: 'View Cash Withdrawal Posting',
    groupName: 'Posting Management',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'cceeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'LOCAL_FUNDS_TRANSFER_POSTING',
    description: 'Local Funds Transfer Posting',
    groupName: 'Posting Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'cdeeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'VIEW_LOCAL_FUNDS_TRANSFER_POSTING',
    description: 'View Local Funds Transfer Posting',
    groupName: 'Posting Management',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'ceeeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'SINGLE_JOURNAL_POSTING',
    description: 'Single Journal Posting',
    groupName: 'Posting Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'cfeeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'VIEW_SINGLE_JOURNAL_POSTING',
    description: 'View Single Posting',
    groupName: 'Posting Management',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'd0eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'BATCH_JOURNAL_POSTING',
    description: 'Batch Journal Posting',
    groupName: 'Posting Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'd1eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'VIEW_BATCH_JOURNAL_POSTING',
    description: 'View Batch Journal Posting',
    groupName: 'Posting Management',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'd2eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'SINGLE_JOURNAL_TO_CUSTOMER_POSTING',
    description: 'Single Journal to Customer Posting',
    groupName: 'Posting Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'd3eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'VIEW_SINGLE_JOURNAL_TO_CUSTOMER_POSTING',
    description: 'View Single Journal to Customer Posting',
    groupName: 'Posting Management',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'd4eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'BATCH_JOURNAL_TO_CUSTOMER_POSTING',
    description: 'Batch Journal to Customer Posting',
    groupName: 'Posting Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'd5eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'VIEW_BATCH_JOURNAL_TO_CUSTOMER_POSTING',
    description: 'View Batch Journal to Customer Posting',
    groupName: 'Posting Management',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'd6eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'BATCH_JOURNAL_UPLOAD_POSTING',
    description: 'Batch Journal Upload Posting',
    groupName: 'Posting Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'd7eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'VIEW_BATCH_JOURNAL_UPLOAD_POSTING',
    description: 'View Batch Journal Upload Posting',
    groupName: 'Posting Management',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'd8eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'BUY_CASH_POSTING',
    description: 'Buy Cash Posting',
    groupName: 'Posting Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'd9eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'VIEW_BUY_CASH_POSTING',
    description: 'View Buy Cash Posting',
    groupName: 'Posting Management',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'daeeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'SELL_CASH_POSTING',
    description: 'Sell Cash Posting',
    groupName: 'Posting Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'dbeeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'VIEW_SELL_CASH_POSTING',
    description: 'View Sell Cash Posting',
    groupName: 'Posting Management',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'dceeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'REVERSAL_POSTING',
    description: 'Reversal Posting',
    groupName: 'Posting Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'ddeeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'VIEW_REVERSAL_POSTING',
    description: 'View Reversal Posting',
    groupName: 'Posting Management',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'deeeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'CHEQUE_WITHDRAWAL_POSTING',
    description: 'Cheque Withdrawal Posting',
    groupName: 'Posting Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'dfeeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'VIEW_CHEQUE_WITHDRAWAL_POSTING',
    description: 'View Cheque Withdrawal Posting',
    groupName: 'Posting Management',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'e0eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'LOCAL_CHEQUE_DEPOSIT_POSTING',
    description: 'Local Cheque Deposit Posting',
    groupName: 'Posting Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'e1eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'VIEW_LOCAL_CHEQUE_DEPOSIT_POSTING',
    description: 'View Local Cheque Deposit Posting',
    groupName: 'Posting Management',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'e2eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'OUTWARD_CHEQUE_DEPOSIT_POSTING',
    description: 'Outward Cheque Deposit Posting',
    groupName: 'Posting Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'e3eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'VIEW_OUTWARD_CHEQUE_DEPOSIT_POSTING',
    description: 'View Outward Cheque Deposit Posting',
    groupName: 'Posting Management',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'e4eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'TELLER_TO_TELLER_POSTING',
    description: 'Teller to Teller Posting',
    groupName: 'Posting Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'e5eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'VIEW_TELLER_TO_TELLER_POSTING',
    description: 'View Teller to Teller Posting',
    groupName: 'Posting Management',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'e6eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'CREATE_ACCOUNT_CATEGORY',
    description: 'Create Account Category',
    groupName: 'Account Category Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'e7eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'MODIFY_ACCOUNT_CATEGORY',
    description: 'Modify Account Category',
    groupName: 'Account Category Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'e8eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'VIEW_ACCOUNT_CATEGORY',
    description: 'View Account Category',
    groupName: 'Account Category Management',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'e9eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'ACTIVATE_ACCOUNT_CATEGORY',
    description: 'Activate Account Category',
    groupName: 'Account Category Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'eaeeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'DEACTIVATE_ACCOUNT_CATEGORY',
    description: 'Deactivate Account Category',
    groupName: 'Account Category Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'ebeeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'VIEW_CHART_OF_ACCOUNT_REPORT',
    description: 'View Chart of Account',
    groupName: 'Financial Reporting Management',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'eceeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'EXPORT_CHART_OF_ACCOUNT_REPORT',
    description: 'Export Chart of Account',
    groupName: 'Financial Reporting Management',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'edeeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'VIEW_TRIAL_BALANCE_REPORT',
    description: 'View Trial Balance Report',
    groupName: 'Financial Reporting Management',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'eeeeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'EXPORT_TRIAL_BALANCE_REPORT',
    description: 'Export Trial Balance Report',
    groupName: 'Financial Reporting Management',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'efeeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'VIEW_PROFIT_OR_LOSS_REPORT',
    description: 'View Profit or Loss Report',
    groupName: 'Financial Reporting Management',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'f0eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'EXPORT_PROFIT_OR_LOSS_REPORT',
    description: 'Export Profit or Loss Report',
    groupName: 'Financial Reporting Management',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'f1eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'VIEW_BALANCE_SHEET_REPORT',
    description: 'View Balance Sheet Report',
    groupName: 'Financial Reporting Management',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'f2eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'EXPORT_BALANCE_SHEET_REPORT',
    description: 'Export Balance Sheet Report',
    groupName: 'Financial Reporting Management',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'f3eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'GL_CLOSING_BALANCE_HISTORY_REPORT',
    description: 'GL Closing Balance History ',
    groupName: 'Management Information System',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'f4eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'CUSTOMER_CLOSING_BALANCE_HISTORY_REPORT',
    description: 'Customer Closing Balance History',
    groupName: 'Management Information System',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'f5eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'TOTAL_DEPOSIT_LIABILITY_REPORT',
    description: 'Total Deposit Liability Report',
    groupName: 'Management Information System',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'f6eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'EXPORT_TOTAL_DEPOSIT_LIABILITY_REPORT',
    description: 'Export Total Deposit Liability Report',
    groupName: 'Management Information System',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'f7eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'TOTAL_OVERDRAWN_ACCOUNT_REPORT',
    description: 'Total Overdrawn Account Report',
    groupName: 'Management Information System',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'f8eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'EXPORT_OVERDRAWN_ACCOUNT_REPORT',
    description: 'Export Overdrawn Account Report',
    groupName: 'Management Information System',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'f9eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'MANAGE_CLEARING_CHEQUES',
    description: 'Manage Clearing Cheques',
    groupName: 'Management Information System',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'faeeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'TRANSACTION_CALLOVER_REPORT',
    description: 'View Transaction Callover Report',
    groupName: 'Operational Reports',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'fbeeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'EXPORT_TRANSACTION_CALLOVER_REPORT',
    description: 'Export Transaction Callover Report',
    groupName: 'Operational Reports',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'fceeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'END_OF_DAY_TRANSACTION_REPORT',
    description: 'View End of Day Transaction Report',
    groupName: 'Operational Reports',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'fdeeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'EXPORT_END_OF_DAY_TRANSACTION_REPORT',
    description: 'Export End of Day Transaction Report',
    groupName: 'Operational Reports',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'feeeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'TOTAL_DEPOSIT_TRANSACTION_REPORT',
    description: 'Veiw Total Deposit Transaction Report',
    groupName: 'Operational Reports',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'ffeeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'EXPORT_TOTAL_DEPOSIT_TRANSACTION_REPORT',
    description: 'Export Total Deposit Transaction Report',
    groupName: 'Operational Reports',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '00efb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'TOTAL_CASH_WITHDRAWAL_REPORT',
    description: 'View Total Cash Withdrawal Report',
    groupName: 'Operational Reports',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '01efb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'EXPORT_TOTAL_CASH_WITHDRAWAL_REPORT',
    description: 'Export Total Cash Withdrawal Report',
    groupName: 'Operational Reports',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '02efb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'TELLER_TILL_REPORT',
    description: "View Teller's Till Report",
    groupName: 'Operational Reports',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '03efb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'EXPORT_TELLER_TILL_REPORT',
    description: "Export Teller's Till Report",
    groupName: 'Operational Reports',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '04efb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'CHECK_MY_TILL_SUMMARY',
    description: 'Check My Till Summary',
    groupName: 'Transaction Reporting',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '87bcf41f-b034-ec11-82dc-0abb469f1216',
    name: 'VIEW_PENALTY',
    description: 'View Penalties',
    groupName: 'Penalty Management',
    isApprovable: false,
    dateCreated: '2021-10-23T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'fe460738-b034-ec11-82dc-0abb469f1216',
    name: 'CREATE_PENALTY',
    description: 'Create Penalties',
    groupName: 'Penalty Management',
    isApprovable: true,
    dateCreated: '2021-10-23T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '9f21aa4c-b034-ec11-82dc-0abb469f1216',
    name: 'MODIFY_PENALTY',
    description: 'Modify Penalties',
    groupName: 'Penalty Management',
    isApprovable: true,
    dateCreated: '2021-10-23T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '243b6160-b034-ec11-82dc-0abb469f1216',
    name: 'ACTIVATE_PENALTY',
    description: 'Activate Penalties',
    groupName: 'Penalty Management',
    isApprovable: true,
    dateCreated: '2021-10-23T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '0316ce6e-b034-ec11-82dc-0abb469f1216',
    name: 'DEACTIVATE_PENALTY',
    description: 'Deactivate Penalties',
    groupName: 'Penalty Management',
    isApprovable: true,
    dateCreated: '2021-10-23T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '1173b523-5458-ec11-82dc-0abb469f1216',
    name: 'BATCH_ACCOUNT_UPLOAD',
    description: 'Batch Account Upload',
    groupName: 'Data Upload',
    isApprovable: true,
    dateCreated: '2021-12-08T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '7e29c63b-5458-ec11-82dc-0abb469f1216',
    name: 'BATCH_LOAN_UPLOAD',
    description: 'Batch Loan Upload',
    groupName: 'Data Upload',
    isApprovable: true,
    dateCreated: '2021-12-08T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'd31b2ed1-bd4b-4110-bbdf-17e5b46adceb',
    name: 'OVERDRAFT_REPORT',
    description: 'View Overdraft Report',
    groupName: 'Credit & Loan Reports',
    isApprovable: false,
    dateCreated: '2022-03-10T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'c365cb95-c7cb-47d0-b603-1b051a65fede',
    name: 'VIEW_EXECUTIVE_DASHBOARD',
    description: 'Executive Dashboard',
    groupName: 'Dashboard Reports',
    isApprovable: false,
    dateCreated: '2022-04-10T10:38:52.5366667',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '05f505cc-edd5-4f37-b128-2878ec5e9f73',
    name: 'EXPORT_OVERDRAFT_REPORT',
    description: 'Export Overdraft Report',
    groupName: 'Credit & Loan Reports',
    isApprovable: false,
    dateCreated: '2022-03-10T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'cd6028ef-8433-4106-8037-29e1e6178fd1',
    name: 'EXPORT_DEPOSITS_BALANCE_REPORT',
    description: 'Export Deposits Balance Report',
    groupName: 'Operational Reports',
    isApprovable: false,
    dateCreated: '2022-03-10T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '9a7770a9-4b00-48c1-bd7f-2b415f38fdc9',
    name: 'EXPORT_LOAN_REPAYMENT_REPORT',
    description: 'Export Loan Repayment Report',
    groupName: 'Credit & Loan Reports',
    isApprovable: false,
    dateCreated: '2022-03-10T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'b4a0471f-f31c-4157-bf9a-319bd2ec47b5',
    name: 'ACCOUNT_BALANCE_MOVEMENT_REPORT',
    description: 'View Account Balance Movement Report',
    groupName: 'Operational Reports',
    isApprovable: false,
    dateCreated: '2022-03-10T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'be5987a6-f271-4be9-a97b-32c63475b0aa',
    name: 'EXPORT_DAILY_TILL_BALANCE_REPORT',
    description: 'Export Daily Till Balance Report',
    groupName: 'Operational Reports',
    isApprovable: false,
    dateCreated: '2022-03-10T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '12befcd4-0442-43c9-aede-354c27bb11d4',
    name: 'VIEW_BASIC_DASHBOARD',
    description: 'General Dashboard',
    groupName: 'Dashboard Reports',
    isApprovable: false,
    dateCreated: '2022-04-10T10:39:45.64',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'ac2655e9-dbe8-4ea3-970c-4d4e0fd6c4cf',
    name: 'GL_HISTORY_REPORT',
    description: 'View GL History Report',
    groupName: 'Operational Reports',
    isApprovable: false,
    dateCreated: '2022-03-10T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '25baf72b-994a-43c4-9cec-4f295ca58c8f',
    name: 'FIXED_DEPOSITS_REPORT',
    description: 'View Fixed Deposits Report',
    groupName: 'Operational Reports',
    isApprovable: false,
    dateCreated: '2022-03-10T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '5b638862-bed2-4213-9916-5706bb967197',
    name: 'EXPORT_GL_HISTORY_REPORT',
    description: 'Export GL History Report',
    groupName: 'Operational Reports',
    isApprovable: false,
    dateCreated: '2022-03-10T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '6de7eaee-673a-437c-9482-6b5eb9bc37e7',
    name: 'EXPORT_LOANS_AND_ADVANCES_REPORT',
    description: 'Export Loan & Advances Report',
    groupName: 'Credit & Loan Reports',
    isApprovable: false,
    dateCreated: '2022-03-10T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '8efc1e0e-3840-4b9f-b0f8-6dafca2c2bfd',
    name: 'DAILY_TILL_BALANCE_REPORT',
    description: 'View Daily Till Balance Report',
    groupName: 'Operational Reports',
    isApprovable: false,
    dateCreated: '2022-03-10T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'e6f4c79d-4a41-44f2-a4fb-75acc1d93242',
    name: 'EXPORT_LOAN_TRACKING_REPORT',
    description: 'Export Loan Tracking Report',
    groupName: 'Credit & Loan Reports',
    isApprovable: false,
    dateCreated: '2022-03-10T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '49c8b404-88aa-416f-a288-7b5ba7f34aa7',
    name: 'LOAN_AND_ADVANCES_REPORT',
    description: 'View Loan & Advances Report',
    groupName: 'Credit & Loan Reports',
    isApprovable: false,
    dateCreated: '2022-03-10T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '689d8a0f-b498-455f-898b-98ac40f7fb1d',
    name: 'ACCOUNT_BALANCE_REPORT',
    description: 'View Account Balance Report',
    groupName: 'Operational Reports',
    isApprovable: false,
    dateCreated: '2022-03-10T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'ff99b473-f376-4341-ae20-9f124410e8ea',
    name: 'EXPORT_ACCOUNT_BALANCE_REPORT',
    description: 'Export Account Balance Report',
    groupName: 'Operational Reports',
    isApprovable: false,
    dateCreated: '2022-03-10T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '76dcd111-5de5-44ef-8935-b543f9260ed1',
    name: 'LOAN_TRACKING_REPORT',
    description: 'View Loan Tracking Report',
    groupName: 'Credit & Loan Reports',
    isApprovable: false,
    dateCreated: '2022-03-10T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '389250d3-32b1-48ee-8c6a-bc477131a44f',
    name: 'EXPORT_ACCOUNT_HISTORY_REPORT',
    description: 'Export Account History Report',
    groupName: 'Operational Reports',
    isApprovable: false,
    dateCreated: '2022-03-10T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '510f6c04-8189-4978-99f3-d80a065085a8',
    name: 'DEPOSITS_BALANCE_REPORT',
    description: 'View Deposits Balance Report',
    groupName: 'Operational Reports',
    isApprovable: false,
    dateCreated: '2022-03-10T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'b7792915-d6e2-4bc0-b9c2-d84161d594c8',
    name: 'EXPORT_ACCOUNT_BALANCE_MOVEMENT_REPORT',
    description: 'Export Account Balance Movement Report',
    groupName: 'Operational Reports',
    isApprovable: false,
    dateCreated: '2022-03-10T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '67b3677e-e6ea-46d1-ae78-d8dea0608345',
    name: 'EXPORT_FIXED_DEPOSITS_REPORT',
    description: 'Export Fixed Deposit Report',
    groupName: 'Operational Reports',
    isApprovable: false,
    dateCreated: '2022-03-10T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'f93f68d8-84d2-4f80-88d0-ea5480fb8395',
    name: 'RESET_PASSWORD',
    description: 'Reset Password',
    groupName: 'User Management',
    isApprovable: false,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: 'bffc0306-167d-49d8-9932-f3b482759f04',
    name: 'LOAN_REPAYMENT_REPORT',
    description: 'View Loan Repayment Report',
    groupName: 'Credit & Loan Reports',
    isApprovable: false,
    dateCreated: '2022-03-10T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '4446315f-9ac3-422d-8527-f589fad1342d',
    name: 'ACCOUNT_HISTORY_REPORT',
    description: 'View Account History Report',
    groupName: 'Operational Reports',
    isApprovable: false,
    dateCreated: '2022-03-10T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
    name: 'DEACTIVATE_MANDATE_STATUS',
    description: 'Deactivate Mandate Status',
    groupName: 'E-Channels Management',
    isApprovable: false,
    dateCreated: '2022-03-10T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
  {
    id: '59eeb1c6-12e7-eb11-82dc-0abb469f1216',
    name: 'DEACTIVATE_BRANCH',
    description: 'Deactivate Branch',
    groupName: 'E-Channels Management',
    isApprovable: true,
    dateCreated: '2021-07-16T00:00:00',
    dateLastModified: null,
    hasApprovalConfigured: false,
  },
]
